import {memo, useCallback, useEffect, useMemo, useState} from "react";
import {Button, Row, Col, Spin, Alert, Typography, Space, Tabs, Card, Divider, Layout, Input, Table} from "antd";
import useSWR from "swr";
import {ExpandAltOutlined, LoadingOutlined} from "@ant-design/icons";
import CareerDrawer from "./CareerDrawer";

const { Search } = Input;

const MainCareer = memo(() => {

    const careerTableColumns = [
        {
            title: 'ลำดับ',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'ชื่ออาชีพ',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'กลุ่ม',
            dataIndex: 'groups',
            key: 'groups',
            render: (text, record) => record?.groups?.join(', ')
        },
        {
            title: 'กลุ่มย่อย',
            dataIndex: 'sub_groups',
            key: 'sub_groups',
            render: (text, record) => record?.sub_groups?.join(', ')
        },
        {
            title: 'ดูข้อมูล',
            key: 'action',
            render: (text, record) => (
                <Button
                    type={'link'}
                    onClick={() => {
                        handleOpenDrawer(record?.id)
                    }}
                >
                    <ExpandAltOutlined /> ดูข้อมูลเพิ่มเติม
                </Button>
            ),
        },
    ];

    const { data: careers, error } = useSWR('/careers');

    const [careerFilter, setCareerFilter] = useState("");
    const [selectedCareerId, setSelectedCareerId] = useState(null);
    const [isOpenCareerDrawer, setIsOpenCareerDrawer] = useState(false);

    const handleOpenDrawer = useCallback((careerId) => {
        setSelectedCareerId(careerId);
        setIsOpenCareerDrawer(true);
    }, [setSelectedCareerId, setIsOpenCareerDrawer])

    const handleCloseDrawer = useCallback(() => {
        setIsOpenCareerDrawer(false);
    }, [setIsOpenCareerDrawer]);

    const filteredCareers = useMemo(() => {
        if (careerFilter.length > 0)
            return careers?.filter(career => {
                return career?.name.toLowerCase().includes(careerFilter.toLowerCase());
            });
        return careers;
    }, [careerFilter, careers]);

    if(error) {
        return <Row justify={'center'} style={{ marginTop: '24px' }}>
            <Col span={20}>
                <Alert
                    message="เกิดข้อผิดพลาด"
                    description={`ไม่สามารถดาวน์โหลดข้อมูลได้ กรุณาลองอีกครั้งภายหลัง : ${error}`}
                    type="error"
                    showIcon
                />
            </Col>
        </Row>
    }

    if(!careers) {
        return <>
            <Row justify={'center'} style={{ marginTop: '24px' }}>
                <Col>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 72 }} spin />} />
                </Col>
            </Row>
        </>;
    }

    return <>
        <div className='container'>
            <Row>
                <Col span={24}>
                    <Search placeholder="ค้นหาชื่ออาชีพ" onSearch={(keyword) => setCareerFilter(keyword)} style={{ width: 300, float: 'right' }} />
                </Col>
            </Row>
            <Row style={{ marginTop: '24px' }}>
                <Col span={24}>
                    <Table
                        columns={careerTableColumns}
                        dataSource={filteredCareers}
                        scroll={{
                            scrollToFirstRowOnChange: true,
                            x: true
                        }}
                    />
                </Col>
            </Row>
        </div>

        <CareerDrawer careerId={selectedCareerId} visible={isOpenCareerDrawer} onClose={() => handleCloseDrawer} />
    </>
});

export default MainCareer;
